export enum DictionaryType {
  RISK_VALUES = 'RISK_VALUES',
  PERSONA_TYPE = 'PERSONA_TYPE',
  OCCUPATION = 'OCCUPATION',
  OCCUPATION_DIRECTOR = 'OCCUPATION_DIRECTOR',
  REJECT_REASON = 'REJECT_REASON',
}
